export default "__VITE_ASSET__533cfd7e__"